<template>
    <div class="container" v-title="teamName">
        <Navigation-bar v-scrollShadow="roll" :title="roll > titleHeight ? teamName : ''">
        </Navigation-bar>
        <div class="container_content" v-show="pageShow">
            <div id="TeamAuditDetail" v-scroll="roll">
                <Pull-refresh 
                    v-model="pullRefresh.loading" 
                    loosing-text="释放刷新数据"
                    loading-text="正在刷新数据..." 
                    :success-text="pullRefresh.text" 
                    @refresh="onRefresh"
                >
                    <Title class="page_title">
                        <template slot="spreadhead">
                            <span>{{teamName}}</span>
                            <span class="noPay" v-if="isNoPay">未支付服务费</span>
                        </template>
                        <template #subtitle>
                            <div class="edit" @click="editDeputation()">
                                <span>修改代表队</span>
                                <YD-image src="icon/icon_card_arrow_2"></YD-image>
                            </div>
                        </template>
                    </Title>
                    <div class="list">
                        <ul>
                            <li v-for="(item,index) in groups" :key="index">
                                <div class="group_title">
                                    <div class="name">{{item.GroupInfo.Name}}</div>
                                    <div class="status" v-if="item.GroupStatus == 1">
                                        <YD-image src="icon/no_audit"></YD-image>
                                    </div>
                                    <div class="status" :class="{'error': [4,6,8].includes(item.GroupStatus)}" v-else-if="item.GroupStatus != null">（{{statusText[item.GroupStatus]}}）</div>
                                    <div v-else></div>
                                </div>
                                <div class="members">
                                    <template v-if="item.GroupInfo.GroupType != 3">
                                        <ol :class="{'max': !moreIndexs.includes(item.GroupInfo.Id)}">
                                            <li v-for="({
                                                baseInfo,
                                                RecordStatus
                                            },userIndex) in item.GroupUserList" :key="userIndex">
                                                <div class="member_info">
                                                    <div class="member_img">
                                                        <img :src="getUserPhoto(baseInfo)" class="member_img">
                                                    </div>
                                                    <span>{{baseInfo.Name}}</span>
                                                    <span class="status" :class="{'error': [4,6,8].includes(RecordStatus)}" v-if="RecordStatus != null">（{{statusText[RecordStatus]}}）</span>
                                                    <span v-else></span>
                                                </div>
                                                <div class="member_role">{{baseInfo.EnrollRoleList[0].RoleName}}{{baseInfo.JerseyNumber ? `(${baseInfo.JerseyNumber})` : ''}}</div>
                                            </li>
                                        </ol>
                                        <div class="more" v-if="item.GroupUserList.length > 2" @click="more(item.GroupInfo.Id)">
                                            <span>{{moreIndexs.includes(item.GroupInfo.Id) ? '收起' : `还有${item.GroupUserList.length - 2}名人员`}}</span>
                                            <YD-image :src="moreIndexs.includes(item.GroupInfo.Id) ? 'icon/icon_card_箭头_灰色_向上' : 'icon/icon_card_箭头_灰色_向下'"></YD-image>
                                        </div>
                                    </template>
                                    <template v-else-if="item.DoublesList.length == 0">
                                        <div class="noDoubles">
                                            你已在该组别中添加队员，但尚未进行队员组合操作。
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="doubles" :class="{'max': !moreIndexs.includes(item.GroupInfo.Id)}">
                                            <template v-for="(doublesItem, doublesIndex) in item.DoublesList">
                                                <div class="doubles_title" :key="'a' + doublesIndex">
                                                    <span>{{doublesItem.PairName}}</span>
                                                    <span class="status" :class="{'error': [4,6,8].includes(doublesItem.PairEnrollStatus)}" v-if="doublesItem.PairEnrollStatus != null">（{{statusText[doublesItem.PairEnrollStatus]}}）</span>
                                                    <span v-else></span>
                                                </div>
                                                <ol :key="'b' + doublesIndex">
                                                    <li v-for="({
                                                        baseInfo,
                                                        RecordStatus
                                                    },userIndex) in doublesItem.UserList" :key="userIndex">
                                                        <div class="member_info">
                                                            <div class="member_img">
                                                                <img :src="getUserPhoto(baseInfo)" class="member_img">
                                                            </div>
                                                            <span>{{baseInfo.Name}}</span>
                                                            <span class="status" :class="{'error': [4,6,8].includes(RecordStatus)}" v-if="RecordStatus != null">（{{statusText[RecordStatus]}}）</span>
                                                            <span v-else></span>
                                                        </div>
                                                        <div class="member_role">{{baseInfo.EnrollRoleList[0].RoleName}}{{baseInfo.JerseyNumber ? `(${baseInfo.JerseyNumber})` : ''}}</div>
                                                    </li>
                                                </ol>
                                            </template>
                                        </div>
                                        <div class="more" v-if="item.DoublesList.length > 1" @click="more(item.GroupInfo.Id)">
                                            <span>{{moreIndexs.includes(item.GroupInfo.Id) ? '收起' : `还有${item.DoublesList.length - 1}个组合`}}</span>
                                            <YD-image :src="moreIndexs.includes(item.GroupInfo.Id) ? 'icon/icon_card_箭头_灰色_向上' : 'icon/icon_card_箭头_灰色_向下'"></YD-image>
                                        </div>
                                    </template>
                                </div>
                                <div class="operation" v-if="isOption">
                                    <span></span>
                                    <div>
                                        <button @click="deleteGroup(item.GroupInfo.Id)">删除此组</button>
                                        <button @click="go(3, item.GroupInfo.Id, item.GroupInfo.GroupType)">修改此组</button>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="group_title">
                                    <div class="name">其他人员</div>
                                    <div></div>
                                </div>
                                <div class="members">
                                    <ol :class="{'max': !moreIndexs.includes(0)}">
                                        <li v-for="(item,index) in otherUsers" :key="index">
                                            <div class="member_info">
                                                <div class="member_img">
                                                    <img :src="getUserPhoto(item)" class="member_img">
                                                </div>
                                                <span>{{item.Name}}</span>
                                            </div>
                                            <div class="member_role">
                                                <template v-for="(roleItem,roleIndex) in item.EnrollRoleList">
                                                    <span :key="roleIndex">{{roleItem.RoleName}}</span>
                                                    <template v-if="roleIndex < item.EnrollRoleList.length - 1"> | </template>
                                                </template>
                                            </div>
                                        </li>
                                    </ol>
                                    <div class="more" v-if="otherUsers.length > 2" @click="more(0)">
                                        <span>{{moreIndexs.includes(0) ? '收起' : `还有${otherUsers.length - 2}名人员`}}</span>
                                        <YD-image :src="moreIndexs.includes(0) ? 'icon/icon_card_箭头_灰色_向上' : 'icon/icon_card_箭头_灰色_向下'"></YD-image>
                                    </div>
                                </div>
                                <div class="operation" v-if="isOption">
                                    <span></span>
                                    <div>
                                        <button  @click="go(2)">修改报名</button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="other_athletes" v-if="noGroupUsers.length > 0">
                        <div>无组别队员不参与审核</div>
                        <ul>
                            <li v-for="(item,index) in noGroupUsers" :key="index">
                                <div>
                                    <div class="member_img">
                                        <img :src="getUserPhoto(item)">
                                    </div>
                                    <div class="member_info">
                                        <div class="member_name">
                                            <span>{{item.Name}}</span>
                                            <template v-if="item.EnrollRoleList && item.EnrollRoleList.length > 0">
                                                <template v-for="(roleItem, roleIndex) in item.EnrollRoleList">
                                                    <i :key="roleIndex">{{roleItem.RoleName}}</i>
                                                </template>
                                            </template>
                                        </div>
                                        <div class="member_group">
                                            <span>暂无组别</span>
                                        </div>
                                    </div>
                                </div>
                                <button v-if="isOption" @click="go(1, item.UserId)">分配组别</button>
                                <span v-else></span>
                            </li>
                        </ul>
                    </div>
                    <div class="noGroups" v-if="noGroups.length > 0">
                        <div>下列组别未添加参赛人员</div>
                        <ul>
                            <li v-for="(item,index) in noGroups" :key="index" @click="isOption ? go(3, item.Id, item.GroupType) : 'javascript:;'">
                                <div class="name">{{item.Name}}<span v-if="getGroupFull(item)">（已报满）</span></div>
                                <div v-if="isOption">
                                    <span>添加</span>
                                    <YD-image src="icon/icon_table_cell_arrow"></YD-image>
                                </div>
                                <div v-else></div>
                            </li>
                        </ul>
                    </div>
                </Pull-refresh>
            </div>
        </div>
        <div class="bottom_operation" v-if="isOption" v-show="pageShow">
            <button @click="submit()">
                <span>提交审核</span>
                <div class="bubble" v-if="isNoSubmitAudit">有组别待提交审核</div>
            </button>
        </div>
    </div>
</template>
<script>
import { PullRefresh } from 'vant';
import 'vant/lib/pull-refresh/style';
import {
    convertSize,
    numberToChinese
} from '@js';
import {
    GetDeputationEnrollRecordDetail, //获取代表队报名详情
    SubmitDeputationEnroll, //代表队报名提交审核
    DelDeputationEnrollGroup //删除代表队报名组别
} from '@/api';
import communicate from '@/common/communicate.js';
import appInteraction from '@/common/appInteraction.js';
export default {
    name:"TeamAuditDetail",
    components:{
        PullRefresh
    },
    data(){
        return{
            deputationEnrollId: 0,
            subLeagueId: 0,
            isGetAuditInfo: true,
            pageShow: false,
            roll:0,
            teamName:"",
            moreIndexs:[],
            groups:[],
            otherUsers:[],
            noGroupUsers:[],
            noGroups:[],
			enrollQuotaStores: [],
            isOption:false,
            isNoPay: false,
            pullRefresh:{
                loading:false,
                text:''
            },
            firstEnter: false, //是否首次进入页面
            hintShowed: false, //重要提示已经显示过
        }
    },
    beforeRouteEnter(to, from, next){
        next(vm => {
            if (from.name === 'TeamPersonnel' || from.name === 'EnrollRecord') {
                vm.firstEnter = true;
            } else {
                vm.firstEnter = false;
            }
        });
    },
    created(){
        this.deputationEnrollId = +(this.$route.query.deputationEnrollId || 0);
        this.subLeagueId = +(this.$route.query.subLeagueId || 0);
        this.isGetAuditInfo = +this.$route.query.audit != 1;
        this.getData();
    },
    activated(){
        this.roll -= 0.001;
        //修改代表队成功
        if(sessionStorage.getItem('editDeputation')){
            sessionStorage.removeItem('editDeputation');
            this.getData();
        }
    },
    computed:{
		statusText(){
			return ['','未提交审核','组委会审核中','组委会审核中','审核有问题','公示中','公示有问题','报名成功','报名失败'];
		},
        titleHeight(){
            return convertSize(1.88);
        },
		portraitUnknown(){
			return require(`@images/portrait_unknown@3x.png`);
		},
		portraitUnknown(){
			return require(`@images/portrait_unknown@3x.png`);
		},
		portraitMan(){
			return require(`@images/肖像_男@3x.png`);
		},
		portraitWoman(){
			return require(`@images/肖像_女@3x.png`);
		},
		isNoSubmitAudit(){
			return this.groups.some(item=>item.GroupStatus == 1);
		}
    },
    methods:{
		getUserPhoto(UserInfo){
			if(UserInfo.PhotolUrl){
				return UserInfo.PhotolUrl;
			}else if(UserInfo.Gender == 1){
				return this.portraitMan;
			}else if(UserInfo.Gender == 2){
				return this.portraitWoman;
			}
			return this.portraitUnknown;
		},
		editDeputation(){
			this.$navigation.go(`/Enroll/AddTeam?subLeagueId=${this.subLeagueId}&deputationEnrollId=${this.deputationEnrollId}`);
		},
        getData(isRefresh){
            GetDeputationEnrollRecordDetail({
                "DeputationEnrollId": this.deputationEnrollId,
                "IsGetAuditInfo": this.isGetAuditInfo
            }).then(data=>{
                if(isRefresh){
                    this.pullRefresh.loading = false;
                    this.pullRefresh.text = data.Code == 0 ? "数据刷新成功" : "数据刷新失败";
                }
                if(data.Code == 0){
                    this.pageShow = true;
					this.isNoPay = data.IsNotPaid;
                    this.teamName = data.DeputationName;
                    this.otherUsers = data.OtherUserList || [];
                    this.noGroupUsers = data.NoGroupUserList || [];
                    this.noGroups = data.NoGroupList || [];
                    this.enrollQuotaStores = data.EnrollQuotaStores || [];
                    this.isOption = data.IsUserCanModify;
                    let GroupList = data.GroupList || [];
                    for(var i=0;i<GroupList.length;i++){
                        let {
                            GroupInfo,
                            GroupUserList
                        } = GroupList[i];
                        if(GroupInfo.GroupType == 3 && GroupUserList){
                            let doublesObj = {},
                                doublesArr = [];
                            for(var j=0;j<GroupUserList.length;j++){
                                let userInfo = GroupUserList[j];
                                let arr = doublesObj[userInfo.baseInfo.PairIndex] || [];
                                arr.push(userInfo);
                                doublesObj[userInfo.baseInfo.PairIndex] = arr;
                            }
                            let num = 0;
                            for(var key in doublesObj){
                                num++;
                                let {
                                    PairId,
                                    PairIndex,
                                    PairEnrollStatus,
                                    PairRejectReason,
                                } = doublesObj[key][0].baseInfo;
                                doublesArr.push({
                                    PairName: '组合' + numberToChinese(num),
                                    PairId,
                                    PairIndex,
                                    PairEnrollStatus,
                                    PairRejectReason,
                                    UserList: doublesObj[key]
                                });
                            }
                            GroupList[i].DoublesList = doublesArr;
                        }else if(!GroupUserList){
                            GroupList[i].DoublesList = [];
                        }
                    }
                    this.groups = GroupList;
                    if(this.firstEnter && !this.hintShowed && this.isGetAuditInfo){
                        this.$nextTick(()=>{
                            this.hintShowed = true;
                            this.$Prompt({
                                title: '重要提示',
                                message: '如果您对自己或队员的报名信息进行了修改，或者在组别中新增、更换、移除了运动员，报名将被自动撤销。请您在修改完成后务必重新提交审核。',
                                confirmText: '我知道了'
                            })
                        });
                    }
                }
            }).catch(()=>{
                if(isRefresh){
                    this.pullRefresh.loading = false;
                    this.pullRefresh.text = "数据刷新失败";
                }
            })
        },
        onRefresh(){
            this.getData(true);
        },
        more(index){
            var moreIndexs = this.moreIndexs;
            if(moreIndexs.indexOf(index) > -1){
                moreIndexs.splice(moreIndexs.indexOf(index),1);
            }else{
                moreIndexs.push(index);
            }
            this.$set(this,'moreIndexs',moreIndexs);
        },
        deleteGroup(groupId){
            this.$Prompt({
                title: '您确定要删除该组别的报名吗？',
                message: '删除后该组所有参赛人员仍将保留在您的代表队名单中',
                showCancel: true
            }).then(confirm=>{
                if(confirm){
                    DelDeputationEnrollGroup({
                        DeputationEnrollId: this.deputationEnrollId,
                        LeagueGroupId: groupId
                    }).then(data=>{
                        if(data.Code == 0){
                            if(!this.isGetAuditInfo){
                                sessionStorage.setItem('deleteGroup',1);
                            }
                            this.$Toast('删除成功','success');
                            this.getData();
                        }
                    })
                }
            })
        },
        submit(){
            SubmitDeputationEnroll({
                DeputationEnrollId: this.deputationEnrollId
            }).then(data=>{
                if(data.Code == 0){
                    communicate.enrollPayStatus.$emit();
                    this.$api.GetSubleagueMatchGroupSetting({
						SubLeagueId: this.subLeagueId
					}).then(data=>{
						if(data.MatchGroupSetting && data.MatchGroupSetting.MatchGroupEnrollRemind == 1){
                            this.$Prompt({
                                title: '报名提交成功',
                                message: '请加入赛事官方微信群，以便随时获得赛事最新信息。',
                                showCancel: true,
                                cancelText: '我已入群',
                                confirmText: '去加群'
                            }).then(confirm=>{
                                if(confirm){
                                    appInteraction.jumpWxMiniApp(`/pages/Match/MatchDetail/MatchDetail?SubLeagueId=${this.subLeagueId}&go=groupQRCode`);
                                }
                                if(!this.isGetAuditInfo){
                                    sessionStorage.removeItem('deleteGroup');
                                }
                                sessionStorage.setItem('auditSuccess',1);
                                this.$navigation.back();
                            })
                        }else{
                            this.$Prompt({
                                title: '提交成功',
                                message: '请在APP中随时关注审核结果',
                                confirmText: '知道了'
                            }).then(()=>{
                                if(!this.isGetAuditInfo){
                                    sessionStorage.removeItem('deleteGroup');
                                }
                                sessionStorage.setItem('auditSuccess',1);
                                this.$navigation.back();
                            })
                        }
                    })
                }else if(data.Code == 3901){
					let enrollQuotaStores = data.EnrollQuotaStores;
					let html = enrollQuotaStores.map(item=>{
						let text = '';
						if(item.LeftNum <= 0){
							text = '已报满';
						}else if(item.GroupInfo.GroupType == 3){
							text = `仅余${item.LeftNum}对`;
						}else if(item.GroupInfo.GroupType == 1){
							text = `仅余${item.LeftNum}人`;
						}else{
                            text = `仅余${item.LeftNum}队`;
                        }
						return `<div style="display: flex;justify-content: space-between;"><div>${item.GroupInfo.Name}</div><div>${text}</div></div>`
					}).join('');
                    this.$Prompt({
                        title: '以下组别可报名额不足，请返回修改：',
                        message: html,
                        confirmText: '知道了'
                    })
				}
            })
        },
		getGroupFull({Id}){
			let obj = this.enrollQuotaStores.find(item=>item.GroupInfo.Id == Id);
			return obj && obj.TotalNum > 0 && obj.LeftNum == 0;
		},
        go(type, id, groupType){
            // if(type == 3){
			// 	if(this.getGroupFull({Id: id})){
            //         this.$Toast.warning('该组别已报满');
			// 		return;
			// 	}
			// }
            if(!this.isGetAuditInfo){
                sessionStorage.setItem('auditOption', JSON.stringify({
                    type,
                    id
                }))
                this.$navigation.back();
            }else{
                this.$navigation.go(`/Enroll/UpdateTeamPersonnel?deputationEnrollId=${this.deputationEnrollId}&subLeagueId=${this.subLeagueId}&type=${type}${id > 0 ? ('&id=' + id) : ''}&groupType=${groupType}`);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin button{
    width: 192px;
    @include line-height(64px);
    font-size: 28px;
    color: #404349;
    letter-spacing: 0;
    font-weight: 500;
    border: 2px solid rgba(233,233,233,1);
    border-radius: 33px;
    margin-left: 16px;
}
#TeamAuditDetail{
    padding-bottom: 232px;
    box-sizing: border-box;
}
.share{
    width: 48px;
    height: 48px;
    margin-right: -6px;
}
.page_title{
	position: relative;
	.noPay{
		font-size: 34px;
		color: #F34911;
		line-height: 34px;
		position: absolute;
		right: 40px;
		top: calc(50% - 17px);
	}
}
.edit{
	display: flex;
	align-items: center;
	span{
		font-weight: 500;
		font-size: 32px;
		color: #7AD21A;
		line-height: 44px;
	}
	img{
		width: 32px;
		height: 32px;
		margin-left: 4px;
	}
}
.list{
    padding: 0 40px;
    box-sizing: border-box;
    ul>li{
        width: 100%;
        height: auto;
        padding: 12px 26px 8px;
        box-sizing: border-box;
        background: #FFFFFF;
        box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
        border-radius: 20px;
        margin-bottom: 24px;
        .group_title{
            width: 100%;
            min-height: 84px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px #F0F0F0 solid;
            .name{
                font-size: 32px;
                color: #1B1C1E;
                font-weight: 500;
				line-height: 44px;
				word-break: break-all;
				padding: 20px 0;
				padding-right: 40px;
				box-sizing: border-box;
                span{
                    color: #7E7E7F;
                }
            }
            .status{
                font-size: 28px;
                font-weight: 400;
                color: #7E7E7F;
				white-space: nowrap;
                &.error{
                    color: #F06E43; 
                }
                img{
                    width: 162px;
                    height: 40px;
                }
            }
        }
        .members{
            height: auto;
            ol{
                padding: 19px 0 16px;
                overflow: hidden;
                &.max{
                    max-height: 128px;
                }
                li{
                    height: 56px;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 16px;
                    &:last-of-type{
                        margin-bottom: 0;
                    }
                    .member_info{
                        display: flex;
                        align-items: center;
                        .member_img{
                            width: 56px;
                            height: 56px;
                            border-radius: 20px;
                            overflow: hidden;
                            display: flex;
                            align-items: center;
                            img{
                                width: 100%;
                            }
                        }
                        span{
                            font-size: 28px;
                            color: #1B1C1E;
                            font-weight: 400;
                            padding-left: 24px;
                        }
                        .status{
                            font-size: 28px;
                            font-weight: 400;
                            color: #7E7E7F;
                            padding: 0;
                            &.error{
                                color: #F06E43; 
                            }
                            image{
                                width: 162px;
                                height: 40px;
                            }
                        }
                    }
                    .member_role{
                        font-size: 28px;
                        color: #999999;
                        font-weight: 400;
                    }
                }
            }
            .doubles{
                padding: 19px 0 0;
                overflow: hidden;
                &.max{
                    max-height: 214px;
                }
                .doubles_title{
                    font-size: 28px;
                    color: #1B1C1E;
                    font-weight: 500;
                    line-height: 40px;
                    margin-bottom: 20px;
                    .status{
                        font-size: 28px;
                        font-weight: 400;
                        color: #7E7E7F;
                        padding: 0;
                        &.error{
                            color: #F06E43; 
                        }
                    }
                }
                ol{
                    padding: 0;
                    margin-bottom: 24px;
                }
            }
            .noDoubles{
                font-size: 28px;
                color: #999999;
                font-weight: 400;
                line-height: 40px;
                padding: 33px 0 8px;
            }
            .more{
                width: 100%;
                height: 56px;
                font-size: 26px;
                color: #7E7E7F;
                font-weight: 400;
                background: #FAFBFA;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    width: 48px;
                    height: 48px;
                }
            }
        }
        .operation{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 24px 0;
            span{
                font-size: 28px;
                color: #7E7E7F;
                font-weight: 400;
            }
            button{
                @include button;
            }
        }
    }
}
.other_athletes{
    padding: 0 40px;
    box-sizing: border-box;
    >div{
        width: 100%;
        height: 104px;
        line-height: 104px;
        font-size: 28px;
        color: #BFC1C5;
        letter-spacing: 0;
        font-weight: 500;
        text-align: center;
    }
    ul {
        width: 100%;
        li{
            width: 100%;
            min-height: 172px;
            padding: 32px 40px;
            padding-right: 26px;
            box-sizing: border-box;
            background: #FFFFFF;
            box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
            border-radius: 20px;
            margin-bottom: 24px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            >div{
                display: flex;
            }
            .member_img{
                width: 108px;
                height: 108px;
                border-radius: 40px;
                overflow: hidden;
                box-shadow: 0 5px 15px 0 rgba(208,212,213,0.80);
                display: flex;
                align-items: center;
                img{
                    width: 100%;
                    height: auto;
                }
            }
            .member_info{
                padding-left: 24px;
                padding-top: 4px;
                box-sizing: border-box;
                .member_name{
                    height: auto;
                    font-size: 32px;
                    color: #1B1C1E;
                    font-weight: 500;
                    line-height: 44px;
                    i{
                        @include line-height(34px);
                        padding: 0 14px;
                        font-size: 24px;
                        color: #FFFFFF;
                        font-weight: 500;
                        font-style: normal;
                        border-radius: 0 17px 17px 16px;
                        margin-left: 8px;
                        display: inline-block;
                        background: #6FD500;
                    }
                }
                .member_group{
                    font-size: 28px;
                    color: #8B8C8D;
                    font-weight: 400;
                    margin-top: 16px;
                    line-height: 40px;
                }
            }
            button{
                @include button;
            }
        }
    }
}
.noGroups{
    padding: 0 40px;
    box-sizing: border-box;
    >div{
        width: 100%;
        height: 104px;
        line-height: 104px;
        font-size: 28px;
        color: #BFC1C5;
        letter-spacing: 0;
        font-weight: 500;
        text-align: center;
    }
    ul li{
        width: 100%;
        min-height: 108px;
        background: #FFFFFF;
        box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
        border-radius: 20px;
        padding: 0 26px;
        box-sizing: border-box;
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name{
            font-size: 32px;
            color: #1B1C1E;
            font-weight: 500;
			line-height: 44px;
			word-break: break-all;
			padding: 32px 0;
			padding-right: 40px;
			box-sizing: border-box;
        }
        .name + div{
            display: flex;
            align-items: center;
            font-size: 28px;
            color: #7E7E7F;
            font-weight: 400;
			line-height: 48px;
			white-space: nowrap;
            img{
                width: 48px;
                margin-right: -2px;
            }
        }
    }
}
.bottom_operation{
    @include bottom-button;
    button{
        position: relative;
		.bubble{
			width: 224px;
			height: 42px;
			background: url('~@images/enroll/bubble_audit@2x.png') no-repeat center / 100%;
			position: absolute;
			top: -24px;
			left: 22px;
			
			font-weight: 500;
			font-size: 24px;
			color: #FFFFFF;
			line-height: 38px;
		}
    }
}
</style>